// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__-9r9a","info":"Panel_info__ZY9pu","btns":"Panel_btns__o+-yR","button":"Panel_button__qx1q8"};